import { SET_CLICKED_NFM, SET_COLLECTION_ITEMS, SET_STAKED_ITEMS, SET_WALLET_ADDRESS } from "./WalletTypes";

export const setWalletAddress = (payload) => {
    return {
        type: SET_WALLET_ADDRESS,
        payload
    }
}

export const setClickedNFM = (payload) => {
    return {
        type: SET_CLICKED_NFM,
        payload
    }
}

export const setCollectionItems = (payload) => {
    return {
        type: SET_COLLECTION_ITEMS,
        payload
    }
}

export const setStakedItems = (payload) => {
  return {
    type: SET_STAKED_ITEMS,
    payload,
  };
};